import { render, staticRenderFns } from "./FrameSurface.vue?vue&type=template&id=4f0429a8&"
import script from "./FrameSurface.vue?vue&type=script&lang=js&"
export * from "./FrameSurface.vue?vue&type=script&lang=js&"
import style0 from "./FrameSurface.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
installComponents(component, {VDivider})
